<template>
  <div :class="componentClasses" @click="clicked()">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'CardContent',
  computed: {
    componentClasses: function () {
      return {
        'gc-card-content': true
      }
    }
  },
  methods: {
    clicked () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>
